import styled from 'styled-components';
import {ChevronLeftIcon, CloseIcon} from '@/components/Icons';
import {BackgroundImage} from './common';

export const IconClose = styled(BackgroundImage)`
  cursor: pointer;
  width: 16px;
  height: 16px;
  background-image: url(${CloseIcon});
`;

export const IconBigClose = styled(BackgroundImage)`
  cursor: pointer;
  width: 24px;
  height: 24px;
  background-image: url(${CloseIcon});
`;

export const BackButton = styled(BackgroundImage)`
  width: 16px;
  height: 16px;
  background-image: url(${ChevronLeftIcon});
  cursor: pointer;
  margin-right: 8px;
`;

export const BigBackButton = styled(BackgroundImage)`
  width: 24px;
  height: 24px;
  background-image: url(${ChevronLeftIcon});
  cursor: pointer;
  margin-right: 8px;
  flex-shrink: 0;
`;
